import { render, staticRenderFns } from "./PropertyServices.vue?vue&type=template&id=2a419065&scoped=true"
import script from "./PropertyServices.vue?vue&type=script&lang=js"
export * from "./PropertyServices.vue?vue&type=script&lang=js"
import style0 from "./PropertyServices.vue?vue&type=style&index=0&id=2a419065&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a419065",
  null
  
)

export default component.exports